import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, clearToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // undefined = checking, null = not authenticated, object = authenticated
  const [user, setUser] = useState(undefined);

  const checkSession = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      clearToken();
      setUser(null);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const loginPassword = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setToken(data.token);
    setUser({ role: data.role, name: data.name });
    return data;
  };

  const loginLicense = async (key) => {
    const { data } = await api.post("/auth/license", { key });
    setToken(data.token);
    setUser({ role: data.role, name: data.name });
    return data;
  };

  const logout = () => {
    clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loginPassword, loginLicense, logout, checkSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
